import { useContext, useRef, useState } from 'react'
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import CustomerService from '../../Services/CustomerService';
// import { MessageThread } from '../../Models/MessageCenter/MessageThread';
// import { BankUserContext } from '../../bankUserContext';
// import paperPlane from "../Images/Triangle.svg";
import paperPlane from "../../../images/Triangle.svg";
// import { LeadDetailsModel } from '../../Models/Lead/LeadDetails
// import SpinnerModel from '../../commonFields/SpinnerModel';
import { Alert } from 'reactstrap';
import { toast } from "react-toastify";
// import { catchError } from '../../Utils/Utils';
import { AxiosError } from 'axios';
import { MessageThread } from '../../../models/QuestionarieMCModal';
import { LeadDetailsModel } from '../../../models/Lead/LeadDetails';
import { TodoModal } from '../../layout/Leads/Notifications/NotificationModal';
import Service from '../../../services';
import { BankUserContext } from '../../../bankUserContext';
import { catchError } from '../../../utils/Utils';
import FinSpinner from '../../../commonfields/FinSpinner';
// import { TodoModal } from '../../Models/NotificationsModel/NotificationModel';
// import { Roles } from '../../Helpers/RolesEnum';
// import RolesAuthentication from '../../Utils/RolesUtlis';

export interface MessageTextProps {
  messageThread?: MessageThread | null;
  messageSend?: any;
  clientDetails?:LeadDetailsModel;
  question?:any;
  clientUserId?: string;
  todo?: TodoModal | null;
  setRefreshCounter?: React.Dispatch<React.SetStateAction<number>>;
  getMessageThreads?: (contextId?: string) => void;
  setViewTodo?: 
    (React.Dispatch<React.SetStateAction<TodoModal | null>>) |
    ((element: TodoModal | null) => void);
    disableforsuperuser:boolean;
}

const MessageTextAreaFC:React.FC<MessageTextProps> =(props: MessageTextProps) =>{
  const [value, setValue] = useState('');
  const service = new Service();
  const bankUserContext = useContext(BankUserContext);
  const [uploadedFileName, setUploadedFileName] = useState<string | undefined>();
  const [uploadedFile, setUploadedFile] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("Unable to process your request, please try again")
  const inputRef = useRef<any>(null);
  // const roles= new RolesAuthentication;
 
  const handleChange = (event: any) => {
    setValue(event.target.value);

  }

 
  const handleDisplayFileDetails = () => {
    if(inputRef?.current?.files && inputRef?.current?.files?.length){
    setUploadedFileName(inputRef.current.files[0].name);
    setUploadedFile(inputRef.current.files[0]);
    }
  };

  const saveManualTodoContextId = (todoUuid: string, contextId: string) => {
    // service.saveManualTodoContextId(todoUuid, contextId)
    //   .then(() => props?.getMessageThreads && props.getMessageThreads(contextId))
    //   .catch(err => catchError(err, true))
  }

  const saveNewMessageThread = ()=>{
    /**
       * Creating message thread when question is not having thread
       */
     const question = props?.question
     const data =
      props?.todo ? {
      clientName:
        `${bankUserContext?.bankuserDetails?.firstName || ''} 
         ${bankUserContext?.bankuserDetails?.lastName || ''}`,
      clientCompany: props?.todo?.companyName || "",
      clientId: bankUserContext?.bankuserDetails?.userId,
      createdBy: bankUserContext?.bankuserDetails?.userId,
      sentTo: props?.todo?.createdBy?.toString(),
      subject: "Todo",
      message: {
        message: value
      },
     } :{
      "clientName": props?.clientDetails?.firstName ? 
      (props?.clientDetails?.firstName + ' ' + props?.clientDetails?.lastName) : "",
      "clientCompany": props?.clientDetails?.company || "",
      "createdBy": bankUserContext?.bankuserDetails?.userId,
      "sentTo": props?.clientUserId,
      "subject": question?.questionText,
      "questionId": question?.clientQuestionId,
      "clientId": props?.clientUserId,
      "message": {
        "message":value,
        "messageType": props?.question?.clientQuestionId?"question":'' // Todo
      }
     };
    
     return service.postSaveMessageThread(data)
     .then(res => {
        if (props?.todo) {
          saveManualTodoContextId(props?.todo?.todoUuid, res?.data);
          props?.setViewTodo && props.setViewTodo({ ...props?.todo, contextId: res?.data }); 
        }
        props?.setRefreshCounter && props.setRefreshCounter(prev => prev + 1);
     })
    .catch((err:AxiosError) => {
      catchError(err,true)
     });

}
  const onFileUpload = () => {
    setLoading(true);
    const data = 
      props?.messageThread && props?.messageThread.id ?
        {
          "id": props?.messageThread.id,
          "message": {
            "createdBy": bankUserContext?.bankuserDetails?.userId,
            "sentTo": props.messageThread?.createdBy === bankUserContext?.bankuserDetails?.userId ? 
            props.messageThread?.sentTo : props.messageThread?.createdBy
          }
        } : {
          "clientName": 
            props?.clientDetails ?
              props?.clientDetails?.firstName ? 
                (props?.clientDetails?.firstName + ' ' + props?.clientDetails?.lastName) : ""
              : 
              // eslint-disable-next-line max-len
              `${bankUserContext?.bankuserDetails?.firstName || ''} ${bankUserContext?.bankuserDetails?.lastName || ''}`,
          "clientCompany": props?.todo ? props?.todo?.companyName : props?.clientDetails?.company || "",
          "createdBy": bankUserContext?.bankuserDetails?.userId,
          "sentTo": props?.todo ? props?.todo?.createdBy?.toString() : props?.clientUserId,
          "subject": props?.todo ? "Todo" : props?.question?.questionText,
          "clientId": props?.clientUserId,
          ...(props?.question && {questionId: props?.question?.clientQuestionId}),
        };
    // Create an object of formData
    const formData = new FormData();
    // Update the formData object
    formData.append("context", JSON.stringify(data));
    formData.append(
      "multipartFile",
      uploadedFile,
      uploadedFileName
    );
  
    // Request made to the backend api
    // Send formData object
    setShowAlert(false);
    service.saveAttachment(formData).then((resp:any) => {
      if(resp && resp.response && resp.response.status !== 200){
          setValue('');
          toast.error(resp?.response?.data);
      } else {
        props?.messageSend && props.messageSend();
        if (props?.todo) {
          !props?.messageThread && saveManualTodoContextId(props?.todo?.todoUuid, resp?.data);
          props?.setViewTodo && props.setViewTodo({ ...props?.todo, contextId: resp?.data }); 
        }
      }
      setValue('');
      inputRef.current.value = "";
      setUploadedFileName('');
      setUploadedFile(null)
      props?.setRefreshCounter && props.setRefreshCounter(prev => prev + 1);
    }).catch(err => {
      catchError(err,true)
    }).finally(()=>{
      setLoading(false);
    })
  
  };
  const sendMessage =  () => {
    let data = {};
    if(!props?.messageThread?.id && value){
         saveNewMessageThread().then(r=>{
          props?.messageSend && props.messageSend()
          setValue('');
         });
    } else {
      if (!uploadedFileName && value && value.length && props?.messageThread?.id) {
        setLoading(true);
        data = {
          id: props.messageThread.id,
          message: {
            "message": value,
            "messageType": "", //Todo
            "createdBy": bankUserContext?.bankuserDetails?.userId,
            "sentTo": 
              props.messageThread?.createdBy === bankUserContext?.bankuserDetails?.userId ? 
                props.messageThread?.sentTo : props.messageThread?.createdBy
          }
        }
      value && service.postSaveMessage(data).then(resp => {
        props?.messageSend && props.messageSend()
        setValue('');
        props?.setRefreshCounter && props.setRefreshCounter(prev => prev + 1);
      }).catch(err => {
        catchError(err,true)
      }).finally(()=>{
        setLoading(false);
      })
    } else if(uploadedFileName){
      onFileUpload();
    }
  }
   
  }
  const closeFile = () => {
    setUploadedFileName('');

  }
  const onDismissAlert = ()=>{
    setShowAlert(false);
  }

  return (
    <div className='message-text-container'>
              {loading && <FinSpinner />}
              {showAlert === true && errorMessage!="" ? 
              <Alert color="danger" isOpen={showAlert} toggle={onDismissAlert} fade={false}>
              {errorMessage}
        </Alert>:""}
      <div>
        {!uploadedFileName ? <textarea
        className='message-text' placeholder="Type a message here"
          value={value} onChange={handleChange}>

        </textarea> : ''
        }
        <img src={paperPlane} onClick={() => sendMessage()}
          className={"sendIcon" } alt=""/>
        {uploadedFileName ? <div className='fileName'>
          {uploadedFileName} <span className='close closeFile' onClick={closeFile}>X</span>
        </div> : ''

        }
        <div  className='attachDocumentSection'>
          <input
            ref={inputRef}
            onChange={handleDisplayFileDetails}
            className="d-none"
            type="file"

            accept="image/jpeg, image/png, image/gif, image/bmp, .pdf, .docx, .xlsx, .csv"
            style={{ display: 'none' }}
            id="contained-button-file" 
          />
          <label htmlFor="contained-button-file" className='attachmentLink'>

            <FontAwesomeIcon
              icon={faPaperclip}
              className="paperclip"
            />
            <span className='attachementLabel'>Attach Document</span>
          </label>
        </div>

      </div>
    </div>



  )
}

export default MessageTextAreaFC
